<div class="flex flex-col space-y-3">
	<p-multiSelect
		[defaultLabel]="BASE_I18N_KEY + '.coaches.ph' | translate"
		[itemSize]="30"
		[ngModel]="controller.observersId$ | async"
		[options]="controller.coachesOptions$ | async"
		[showToggleAll]="false"
		[style]="{ width: '100%' }"
		[virtualScroll]="true"
		(ngModelChange)="onObserversIdChange($event)"
		appendTo="body"
	></p-multiSelect>
	<button
		[label]="BASE_I18N_KEY + '.update.label' | translate"
		(click)="onUpdateClick()"
		class="self-end"
		pButton
	></button>
</div>
